export const global = {
  body: {
    bg: 'brand.1300',
    color: 'brand.900',
  },
  // styles for the `a`
  a: {
    color: 'brand.500',
    _hover: {
      textDecoration: 'none',
    },
  },
  input: {
    border: '',
  },
  h1: {
    fontSize: '35px',
    color: 'brand.900',
    fontWeight: 'bold',
  },
  h4: {
    fontSize: '18px',
    color: 'brand.900',
    fontWeight: 'bold',
  },
};
